import getDocument from './getDocument';
import getWindow from './getWindow';
let portalId;
export const getPortalId = () => {
  if (portalId) return portalId;
  const portalIdArray = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/.exec(getDocument().location.pathname);
  const currentWindow = getWindow();
  portalId = portalIdArray && portalIdArray.length > 1 ? Number(portalIdArray[1]) : currentWindow.hubspot !== undefined && currentWindow.hubspot.portal !== undefined ? currentWindow.hubspot.portal.id : undefined;
  return portalId;
};
export const clearPortalIdCache = () => {
  portalId = undefined;
};